<template>
  <label class="uploader" @drop.prevent="drop" @dragover.prevent>
    <div class="uploader__placeholder">
      <div>
        {{ value ? value.name : placeholderTitle }}
      </div>
      <div class="uploader__placeholder-detail" v-if="!value">
        {{ placeholderDesc }}
      </div>
    </div>
    <input
      accept="image/*,video/*"
      @change="handleChange"
      class="uploader__input"
      type="file"
    />
  </label>
</template>

<script>
export default {
  name: "Uploader",
  props: {
    value: File,
    placeholderTitle: String,
    placeholderDesc: String
  },
  methods: {
    handleChange(event) {
      const file = event.target.files[0];
      this.$emit("input", file);
    },
    drop(e) {
      const file = e.dataTransfer.files[0];
      this.$emit("input", file);
    }
  }
};
</script>

<style scoped lang="scss">
.uploader {
  display: flex;
  color: #c4c4c4;
  border: 2px dashed;
  min-height: 145px;
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    color: white;
  }

  &__placeholder {
    font-family: $body-font-family, sans-serif;
    font-size: 36px;
    text-align: center;
    font-weight: 700;
    &-detail {
      font-size: 18px;
    }
  }

  &__input {
    display: none;
  }
}
</style>
